export default __webpack_public_path__ + "static/diameter-522ee678fa6c4477b1ded891091e9a32.png";